import ReportView from './ReportView';

/**
 * Order line report — one row per product line across orders, for
 * product-wise and brand/category sales analysis.
 */
export default function OrderLinesReportPage() {
  return (
    <ReportView
      title="Order line report"
      subtitle="One row per product line — quantities, rates and GST per item across all orders in a range."
      endpoint="/reports/order-lines"
      storageKey="report.cols.orderLines"
      exportName="order-line-report"
      defaultColumns={['orderNo', 'orderDate', 'customer', 'product', 'quantity', 'unitPrice', 'taxable', 'lineTotal']}
      statusOptions={[
        { value: 'pending', label: 'Pending' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'dispatched', label: 'Dispatched' },
        { value: 'delivered', label: 'Delivered' },
        { value: 'cancelled', label: 'Cancelled' },
      ]}
    />
  );
}
